const menuItems = document.querySelectorAll('.tab-menu li');
if(menuItems.length>0){
    let initiallyActiveItem = document.querySelector('.tab-menu li.active');
    let lastHoveredItem = initiallyActiveItem;
    menuItems.forEach(item => {
        item.addEventListener('mouseover', function() {
            lastHoveredItem.classList.remove('active');
            this.classList.add('active');
            lastHoveredItem = this;
            if (initiallyActiveItem !== this) {
                initiallyActiveItem.classList.remove('active');
            }
        });
    });

    document.querySelector('.tab-menu').addEventListener('mouseleave', function() {
        lastHoveredItem.classList.remove('active');
        initiallyActiveItem.classList.add('active');
    });
}